/*
 * Copyright © 2026 MS IMAGES. All rights reserved.
 * Proprietary and confidential — unauthorized copying, distribution, or use
 * of this file, via any medium, is strictly prohibited. See LICENSE.
 */

/**
 * Renders the running build as "PROD · V0.1.0001".
 *
 * Used in every shell footer so that whoever is looking at the app can tell
 * which box and which build they are on without asking anyone.
 */

import { APP_VERSION, BUILD_TIME, getEnvironment, getVersionLabel } from '@/config/version';

export function AppVersion() {
  const env = getEnvironment();
  const label = getVersionLabel(env);
  const built = BUILD_TIME ? new Date(BUILD_TIME).toLocaleString() : 'dev build';

  return (
    <span
      className={`app-version app-version--${env.toLowerCase()}`}
      title={`Version ${APP_VERSION}\nEnvironment: ${env}\nBuilt: ${built}`}
    >
      {label}
      <style>{`
        .app-version {
          font-size: inherit;
          color: inherit;
          white-space: nowrap;
        }

        /* Non-production boxes are tinted so a UAT tab is never mistaken
           for production during a demo. */
        .app-version--uat {
          color: var(--color-warning);
          font-weight: 600;
        }

        .app-version--dev {
          color: var(--color-info);
          font-weight: 600;
        }
      `}</style>
    </span>
  );
}

export default AppVersion;
